import * as React from 'react';
import * as autoBind from 'react-autobind';
import {AlertModal, TscButtonTypes} from '@techsmith/tsc-cloud-style-guide';
import Constants from '../../globals/Constants';
import ModalEventHandlersModel from '../../types/ModalEventHandlers';

export default class EventHandlingModal extends React.Component<EventHandlingModalProps, {}> {
   constructor(props: EventHandlingModalProps) {
      super(props);
      autoBind(this);
   }

   onKeyDown(e: KeyboardEvent) {
      if (e.keyCode === Constants.keys.escape) {
         this.props.defaultOnClose();
      }
   }

   componentDidMount() {
      window.addEventListener('keydown', this.onKeyDown);
   }

   componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyDown);
   }

   onClose() {
      const {modalEventHandlers, defaultOnClose} = this.props;

      if (modalEventHandlers.onClose) {
         modalEventHandlers.onClose();
      }
      defaultOnClose();
   }

   onConfirm() {
      const {modalEventHandlers, defaultOnClose} = this.props;

      if (modalEventHandlers.onConfirm) {
         modalEventHandlers.onConfirm();
      }
      defaultOnClose();
   }

   onDismiss() {
      const {modalEventHandlers, defaultOnClose} = this.props;

      if (modalEventHandlers.onDismiss) {
         modalEventHandlers.onDismiss();
      }
      defaultOnClose();
   }

   render() {
      const {visible, title, closeContent, confirmContent, confirmButtonType, dismissContent, children, testId} = this.props;
      const alertModal = <AlertModal title={title}
                                     onClose={this.onClose}
                                     closeContent={closeContent}
                                     onConfirm={this.onConfirm}
                                     confirmContent={confirmContent}
                                     confirmButtonType={confirmButtonType}
                                     onDismiss={this.onDismiss}
                                     dismissContent={dismissContent}
                                     testId={testId}>
         {children}
      </AlertModal>;

      return visible ? alertModal : null;
   }
}

export interface EventHandlingModalProps {
   visible: boolean;
   modalEventHandlers: ModalEventHandlersModel;
   title: string;
   closeContent: string;
   confirmContent: string;
   confirmButtonType: TscButtonTypes;
   dismissContent: string;
   testId: string;
   children: React.ReactNode;
   defaultOnClose(): void;
}
